import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import logo from "../../assets/icons/Logo001.png";
import { getS3URL } from "../../_helpers";
import { FaPause } from "react-icons/fa";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import "tippy.js/themes/light.css";
import CartButton from "../Courses/CourseTile/CartButton/CartButton";
import moment from "moment";

const slugify = (text) =>
  text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^\w\-]+/g, "")
    .replace(/\-\-+/g, "-")
    .replace(/^-+/, "")
    .replace(/-+$/, "");

const getLearningOutcomes = (courseName) => {
  const name = (courseName || "").toLowerCase();
  if (name.includes("ai") || name.includes("artificial intelligence") || name.includes("machine learning")) {
    return [
      "Build a comprehensive understanding of AI architectures and model structures.",
      "Design and deploy production-ready intelligence pipelines from scratch.",
      "Learn to leverage cutting-edge tools like LLMs, LangChain, and Transformers."
    ];
  }
  if (name.includes("python") || name.includes("code") || name.includes("programming")) {
    return [
      "Master core programming concepts, algorithms, and data structures.",
      "Write clean, professional, and optimized pythonic code.",
      "Build hands-on automation, scripting, and data processing tools."
    ];
  }
  if (name.includes("data") || name.includes("analytic") || name.includes("science")) {
    return [
      "Analyze complex datasets using modern analytic techniques and libraries.",
      "Visualize trends and build interactive reports for stakeholders.",
      "Perform statistical hypothesis testing and predictive modeling."
    ];
  }
  return [
    "Gain in-demand skills and hands-on experience through practical exercises.",
    "Master the fundamental workflows, libraries, and best-practice tools.",
    "Access career-boosting templates and complete resources from experts."
  ];
};


const MostPopularCertificates = () => {
  const { courses } = useSelector((state) => state?.course || []);
  const courseList = courses?.all?.courses || [];
  const navigate = useNavigate();


  const marqueeRef = useRef(null);
  const [isPaused, setIsPaused] = useState(false);
  const [isPopoverActive, setIsPopoverActive] = useState(false);
  const [speed, setSpeed] = useState('normal');
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  // Filter courses with enrollment count > 0
  const filteredCourses = courseList.filter((cert) => cert.courseViews > 0);

  // Create multiple copies for seamless infinite scroll
  const marqueeItems = [...filteredCourses, ...filteredCourses, ...filteredCourses];

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const marqueeElement = marqueeRef.current;
    if (!marqueeElement || filteredCourses.length === 0) return;

    // Remove existing style if any
    const existingStyle = document.getElementById('marquee-style');
    if (existingStyle) {
      existingStyle.remove();
    }

    // CSS animation approach for smooth marquee
    const style = document.createElement('style');
    style.id = 'marquee-style';

    // Calculate total width of one set of items
    const itemWidth = 370 + 24; // card width + gap
    const totalWidth = filteredCourses.length * itemWidth;

    // Speed settings
    const speedMap = {
      slow: filteredCourses.length * 8,
      normal: filteredCourses.length * 4,
      fast: filteredCourses.length * 2
    };

    style.textContent = `
      @keyframes marqueeSlide {
        0% {
          transform: translateX(0);
        }
        100% {
          transform: translateX(-${totalWidth}px);
        }
      }
      
      .marquee-container {
        animation: marqueeSlide ${speedMap[speed]}s linear infinite;
      }
      
      .marquee-paused {
        animation-play-state: paused;
      }
      
      .marquee-container:hover {
        animation-play-state: paused;
      }

      /* Premium Tippy Popover custom styles */
      .tippy-box[data-theme~='premium-popover'] {
        background-color: transparent !important;
        box-shadow: none !important;
        border: none !important;
        max-width: 360px !important;
        padding: 0 !important;
      }
      
      .tippy-box[data-theme~='premium-popover'] .tippy-content {
        padding: 0 !important;
      }
      
      .tippy-box[data-theme~='premium-popover'] .tippy-arrow {
        color: #ffffff !important;
      }
      
      /* Premium Add to Cart / Go to Cart button styling inside the popover */
      .popular-course-cart-wrapper a {
        background: #6a11cb !important;
        background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%) !important;
        color: #ffffff !important;
        padding: 12px 16px !important;
        border-radius: 10px !important;
        font-size: 14px !important;
        font-weight: 700 !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        width: 100% !important;
        text-align: center !important;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
        box-shadow: 0 4px 14px rgba(106, 17, 203, 0.25) !important;
        border: none !important;
        text-transform: uppercase !important;
        letter-spacing: 0.5px !important;
        text-decoration: none !important;
      }
      
      .popular-course-cart-wrapper a:hover {
        transform: translateY(-2px) !important;
        box-shadow: 0 6px 20px rgba(106, 17, 203, 0.4) !important;
        opacity: 0.95 !important;
      }
      
      .popular-course-cart-wrapper a:active {
        transform: translateY(0) !important;
      }

      .popular-course-cart-wrapper a.disabled {
        background: #e2e8f0 !important;
        background-image: none !important;
        color: #94a3b8 !important;
        box-shadow: none !important;
        cursor: not-allowed !important;
        transform: none !important;
      }
    `;

    document.head.appendChild(style);

    return () => {
      const styleToRemove = document.getElementById('marquee-style');
      if (styleToRemove) {
        styleToRemove.remove();
      }
    };
  }, [filteredCourses.length, speed]);

  const handleViewProgram = (course) => {
    const slug = slugify(course.CourseName);
    navigate(`/${slug}`, { state: { course } });
  };

  // const renderHoverboxContent = (cert) => {
  //   const outcomes = getLearningOutcomes(cert.CourseName);
  //   const duration = cert.Duration || cert.duration || 32;
  //   const level = cert.Level || cert.level || "All Levels";
  //   const language = cert.Language || "English";
  //   const updatedDate = cert.CreatedOn || cert.createdAt || cert.updatedAt || new Date();

  //   return (
  //     <div className="premium-hoverbox bg-white border border-slate-100 rounded-2xl shadow-[0_12px_40px_rgba(0,0,0,0.12)] p-6 w-[360px] text-left transition-all duration-300">
  //       {/* Title */}
  //       <h4 className="text-gray-900 font-bold text-base leading-snug mb-2 hover:text-[#2575fc] transition-colors duration-200">
  //         {cert.CourseName}
  //       </h4>

  //       {/* Badges / Status */}
  //       <div className="flex items-center gap-3 mb-3 flex-wrap">
  //         <span className="bg-emerald-50 text-emerald-800 text-[10px] font-bold px-2 py-0.5 rounded border border-emerald-100 uppercase tracking-wide">
  //           Bestseller
  //         </span>
  //         <span className="text-emerald-600 font-semibold text-xs flex items-center gap-1">
  //           <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse"></span>
  //           Updated {moment(updatedDate).format("MMMM YYYY")}
  //         </span>
  //       </div>

  //       {/* Course Info Stats */}
  //       <p className="text-gray-500 text-xs font-medium mb-3 flex items-center gap-1.5">
  //         <span>{duration} total hours</span>
  //         <span className="text-gray-300">•</span>
  //         <span>{level}</span>
  //         <span className="text-gray-300">•</span>
  //         <span>{language}</span>
  //       </p>

  //       {/* Description / One Liner */}
  //       <p className="text-gray-600 text-xs leading-relaxed mb-4 border-b border-gray-100 pb-3 italic">
  //         {cert.Description && cert.Description.length >= 10
  //           ? cert.Description.replace(/<[^>]+>/g, "").substring(0, 120) + "..."
  //           : "Master key techniques and workflows with comprehensive, step-by-step guidance from industry leading professionals."}
  //       </p>

  //       {/* Learning Objectives/Outcomes */}
  //       <div className="mb-4">
  //         <h5 className="text-gray-800 text-[11px] font-bold uppercase tracking-wider mb-2">
  //           What you'll learn:
  //         </h5>
  //         <ul className="space-y-1.5">
  //           {outcomes.map((outcome, idx) => (
  //             <li key={idx} className="flex items-start gap-2 text-xs text-gray-600">
  //               <span className="text-emerald-500 font-bold mt-0.5 text-sm flex-shrink-0">✓</span>
  //               <span className="leading-tight">{outcome}</span>
  //             </li>
  //           ))}
  //         </ul>
  //       </div>

  //       {/* Add to Cart Button wrapper */}
  //       <div className="popular-course-cart-wrapper w-full mt-4 pt-1">
  //         <CartButton post={{ ...cert, ID: cert.ID || cert.id }} />
  //       </div>
  //     </div>
  //   );
  // };

  if (filteredCourses.length === 0) {
    return (
      <div className="max-w-7xl mx-0 px-0 py-10">
        <div className="text-center text-gray-500">
          No popular courses available at the moment.
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-12xl mx-0 px-6 py-10">
      <div>
         
        <h2 className="text-3xl md:text-4xl font-bold mt-2 text-gray-900">
          Most Popular Courses
        </h2>
        <p className="text-gray-600 mt-2">
          Explore our most popular programs, get job-ready for an in-demand career.
        </p>
      </div>

      {/* Marquee Container */}
      <div className="mt-8 overflow-hidden bg-gradient-to-r from-transparent via-gray-50 to-transparent py-4">
        <div
          ref={marqueeRef}
          className={`flex space-x-6 marquee-container ${(isPaused || isPopoverActive) ? 'marquee-paused' : ''}`}
          style={{ width: 'max-content' }}
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
        >
          {marqueeItems.map((cert, index) => (
            // <Tippy
            //   key={`${cert.id || cert.ID || index}-${index}`}
            //   theme="premium-popover"
            //   interactive={true}
            //   placement="right-start"
            //   disabled={screenWidth < 1024}
            //   onShow={() => setIsPopoverActive(true)}
            //   onHide={() => setIsPopoverActive(false)}
            //   content={renderHoverboxContent(cert)}
            // >
              <div
                className="w-[370px] bg-white shadow-[0_8px_30px_rgba(0,0,0,0.04)] rounded-2xl overflow-hidden group hover:shadow-[0_30px_60px_rgba(0,0,0,0.12),0_12px_24px_rgba(0,0,0,0.08)] hover:-translate-y-3 hover:scale-[1.03] transition-all duration-500 ease-out cursor-pointer flex-shrink-0 border border-slate-100 hover:border-slate-200/80"
                onClick={() => handleViewProgram(cert)}
              >
                {/* Image Section */}
                <div className="relative overflow-hidden h-48 bg-slate-50">
                  <img
                    src={getS3URL(cert?.imageFiles[0]?.fileName)}
                    alt={cert?.CourseName}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = require("../../assets/images/bgimages.webp");
                    }}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
                  />
                  
                  {/* Bestseller Badge */}
                  {/* <div className=" top-3 right-3 bg-white/90 backdrop-blur-md px-3 py-1 rounded-lg text-[10px] font-bold text-amber-600 shadow-sm flex items-center gap-1 uppercase tracking-wider border border-white/20">
                    <span className="text-xs">★</span>
                    <span>Bestseller</span>
                  </div> */}

                  {/* Duration Badge */}
                  {/* <div className="absolute bottom-0 right-3 bg-slate-900/75 backdrop-blur-sm px-2 py-0.5 rounded text-[10px] font-semibold text-white tracking-wide">
                    {cert.Duration || cert.duration || 32} Hours
                  </div> */}
                </div>

                {/* Details Section */}
                <div className="p-5">
                  {/* Category / Rating Row */}
                  <div className="flex items-center justify-between mb-3.5">
                    <span className="text-[10px] font-bold text-indigo-600 bg-indigo-50/80 px-2.5 py-0.5 rounded-full uppercase tracking-wider border border-indigo-100/50">
                      {cert.Level || cert.level || "All Levels"}
                    </span>
                    <div className="flex items-center gap-1 text-[11px] font-bold text-amber-500">
                      <span>★</span>
                      <span className="text-slate-700 font-semibold">{cert.Rating || cert.rating || "4.8"}</span>
                    </div>
                  </div>

                  {/* Title */}
                  <h3 className="text-[15px] font-bold text-slate-800 mb-2 group-hover:text-indigo-600 transition-colors duration-300 line-clamp-2 h-11 leading-snug">
                    {cert.CourseName}
                  </h3>

                  {/* Description */}
                  <p className="text-slate-500 text-xs leading-relaxed mb-4 line-clamp-2 h-9">
                    {cert.Description && cert.Description.length >= 30
                      ? `${cert.Description.slice(0, 80).replace(/<[^>]+>/g, "")}...`
                      : cert.Description?.replace(/<[^>]+>/g, "") || "Master key tools and templates with step-by-step expert guides."}
                  </p>

                  {/* Footer - Enrollment & Learn More CTA */}
                  <div className="flex items-center justify-between pt-3.5 border-t border-slate-100">
                    <span className="flex items-center gap-1.5 text-[11px] font-bold text-slate-500 bg-slate-50 px-2.5 py-1 rounded-lg border border-slate-100/50">
                      <svg className="w-3.5 h-3.5 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                      </svg>
                      {cert.enrollmentCount.toLocaleString()} Students
                    </span>
                    <span className="text-xs font-bold text-indigo-600 flex items-center gap-0.5 group-hover:translate-x-0.5 transition-all duration-300">
                      Learn More
                      <span className="text-sm font-semibold">→</span>
                    </span>
                  </div>
                </div>
              </div>
            // </Tippy>
          ))}
        </div>
      </div>

      {/* Speed Control */}
      {/* <div className="flex justify-center mt-6 space-x-2">
        <span className="text-sm text-gray-600 mr-4 self-center">Speed:</span>
        {['slow', 'normal', 'fast'].map((speedOption) => (
          <button
            key={speedOption}
            onClick={() => setSpeed(speedOption)}
            className={`px-4 py-2 text-sm rounded-lg transition-all ${
              speed === speedOption
                ? 'bg-blue-600 text-white shadow-md'
                : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
            }`}
          >
            {speedOption.charAt(0).toUpperCase() + speedOption.slice(1)}
          </button>
        ))}
      </div> */}

      {/* Pause indicator */}
      {/* {isPaused && (
        <div className="text-center mt-4">
          <div className="border text-sm text-gray-500 bg-[#264b82]  w-10 h-10 rounded-full inline-flex items-center gap-2">
            <FaPause className="text-white ml-3" />
          </div>
        </div>
      )} */}
    </div>
  );
};

export default MostPopularCertificates;
